import { graphql, StaticQuery } from "gatsby"
import PropTypes from "prop-types"
import React, { createContext, useMemo, useState } from "react"
import RequestDemoModal from "./modals/RequestDemoModal"
import NotifyMeModal from "./modals/NotifyMeModal";
import SubmitTicketModal from "./modals/SubmitTicketModal";

export const ModalContext = createContext(undefined);

export const ModalProvider = (props) => {
  const [showModal, setShowModal] = useState(false)

  const value = useMemo(() => [showModal, setShowModal], [showModal])

  return <ModalContext.Provider value={value} {...props} />
}

const Layout = ({ children, isNotifyMe = false, isSupportPage = false, notifyMeEmail, onModalClose = null }) => {
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={(data) => (
        <ModalProvider>
          <main style={{ position: "relative" }}>{children}</main>
            {   isNotifyMe ? <NotifyMeModal notifyMeEmail={notifyMeEmail} onModalClose={onModalClose} />
                    : isSupportPage ? <SubmitTicketModal onModalClose={onModalClose} />
                    : <RequestDemoModal />
            }

            {/* Hidden forms to make netlify bots detect form inside modal */}
            <form
                name="Request Demo Form"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                action="/book-a-demo/#book-a-zcal-demo"
                hidden
            >
                <input type="email" name="email" />
                <input type="text" name="fullName" />
                <input type="text" name="company" />
                <input type="text" name="companyRole" />
            </form>
            <form
                name="Notify Me Form"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                action="/public-portfolios/#notify-me-email-form"
                hidden
            >
                <input type="email" name="email" />
                <input type="text" name="fullName" />
                <input type="text" name="company" />
                <input type="text" name="companyRole" />
            </form>
            <form
                name="Submit a Ticket Form"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                action="/support/#submit-a-ticket"
                hidden
            >
                <input type="email" name="email" />
                <input type="text" name="fullName" />
                <input type="text" name="description" />
                <input type="select" name="severity" />
            </form>
        </ModalProvider>
      )}
    />
  )
}


Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
